import { ReviewRequest, User } from '../types';

export const reviewerId = (u: User | string): string => (typeof u === 'string' ? u : u._id);

export type ReviewerVoteState = 'approved' | 'rejected' | 'awaiting';

export interface ReviewerVote {
  user: User | string;
  state: ReviewerVoteState;
  comment?: string;
}

/** Count of required reviewers who have approved, out of the total required. */
export const getReviewProgress = (request: ReviewRequest): { approved: number; total: number } => {
  const required = request.requiredReviewers || [];
  const approvedIds = new Set(
    (request.approvals || [])
      .filter((a) => a.decision === 'approved')
      .map((a) => reviewerId(a.user)),
  );
  return {
    approved: required.filter((r) => approvedIds.has(reviewerId(r))).length,
    total: required.length,
  };
};

/** True when the request is routed to a pool of required signers (unanimous flow). */
export const hasRequiredReviewers = (request: ReviewRequest): boolean =>
  (request.requiredReviewers || []).length > 0;

/** Per-reviewer vote state for the required signers, for detail views. */
export const getReviewerVotes = (request: ReviewRequest): ReviewerVote[] => {
  const votes = request.approvals || [];
  return (request.requiredReviewers || []).map((reviewer) => {
    const id = reviewerId(reviewer);
    const vote = votes.find((v) => reviewerId(v.user) === id);
    return {
      user: reviewer,
      state: (vote?.decision as ReviewerVoteState) || 'awaiting',
      comment: vote?.comment,
    };
  });
};
